import { useIntl } from 'react-intl';

import { useTripListItem } from '@src/contexts/trip-list-item-context';

import { Card } from './card';
import {
  Dates,
  DatesArrow,
  GuestName,
  MobileOnGoingFutureTripCardContent,
  MobileOnGoingFutureTripCardImage,
  MobileOnGoingFutureTripCardWrapper,
  PropertyName,
} from './styles';

export const MobileOnGoingFutureTripCard = () => {
  const {
    trip,
    trip: { primaryGuest },
  } = useTripListItem();

  const intl = useIntl();

  const checkInDate = intl.formatDate(trip.arrival, {
    weekday: 'short',
    day: '2-digit',
    month: 'short',
    timeZone: trip.property.timezone,
  });

  const checkOutDate = intl.formatDate(trip.departure, {
    weekday: 'short',
    day: '2-digit',
    month: 'short',
    timeZone: trip.property.timezone,
  });

  const image = trip.unitGroup.pictures[0]?.responsiveImage;
  const mainGuestName =
    primaryGuest.firstName && primaryGuest.lastName ? `${primaryGuest.firstName} ${primaryGuest.lastName}` : '';

  return (
    <MobileOnGoingFutureTripCardWrapper href={`/trips/${trip.id}`}>
      <MobileOnGoingFutureTripCardImage>
        <Card.Badge tripStatus={trip.status} arrivalDate={trip.arrival} timeZone={trip.property.timezone} />

        {image && <Card.Image {...image} alt={image.alt ?? undefined} title={image.title ?? undefined} />}
      </MobileOnGoingFutureTripCardImage>
      <MobileOnGoingFutureTripCardContent>
        <PropertyName>{trip.property.name}</PropertyName>
        <Dates>
          <span>{checkInDate}</span>
          <DatesArrow />
          <span>{checkOutDate}</span>
        </Dates>
        {mainGuestName && <GuestName>{mainGuestName}</GuestName>}
      </MobileOnGoingFutureTripCardContent>
    </MobileOnGoingFutureTripCardWrapper>
  );
};
